import React, { useEffect, useRef } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { motion, useAnimation } from 'framer-motion';
import img1 from '../../../assets/QU_ispa.jpg';
import './about.css';

function AppAbout() {
  const controls = useAnimation();
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            controls.start('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [controls]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };

  const imageVariants = {
    hidden: { x: -50, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };

  const buttonVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.5,
        delay: 0.6
      }
    },
    hover: {
      scale: 1.05,
      boxShadow: "0 8px 24px rgba(0, 118, 31, 0.2)",
      transition: {
        duration: 0.3
      }
    }
  };

  return (
    <motion.section
      ref={sectionRef}
      id="about"
      className="block about-block"
      initial="hidden"
      animate={controls}
      variants={containerVariants}
      style={{ overflow: 'hidden' }} // Adicionado para prevenir overflow
    >
      <div className="about-bg-pattern"></div>
      
      <Container>
        {/* Cabeçalho */}
        <motion.div 
          className="title-holder"
          variants={itemVariants}
        >
          <motion.h2 
            className="section-title"
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Quem Somos
          </motion.h2>
          <motion.p 
            className="section-subtitle"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            Excelência Acadêmica, Inovação e Impacto Social
          </motion.p>
          <motion.div 
            className="section-underline"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          />
        </motion.div>

        <Row className="align-items-center g-5">
          {/* Coluna da Imagem */}
          <Col lg={6} className="order-lg-1 order-2">
            <motion.div
              className="image-wrapper"
              variants={imageVariants}
            >
              <img
                src={img1}
                alt="Instituto Superior Politécnico Atlântida"
                className="about-image"
              />
              <div className="image-border"></div>
            </motion.div>
          </Col>

          {/* Coluna do Texto */}
          <Col lg={6} className="order-lg-2 order-1">
            <motion.div 
              className="content-card"
              variants={itemVariants}
            >
              <motion.p className="about-text">
                O <strong>Instituto Superior Politécnico Atlântida</strong>, fundado em 2012 e legalizado pelo Decreto Presidencial Nº 168, está localizado em Luanda. A instituição é dotada de autonomia estatutária pedagógica, científica, cultural e administrativa.
              </motion.p>
              
              <motion.p className="about-text">
                Estruturado em quatro grandes áreas do conhecimento, o ISPA oferece <strong>15 cursos de graduação</strong>, distribuídos entre as Ciências da Saúde, Engenharias e Tecnologias, Gestão e Ciências Sociais.
              </motion.p>

              {/* Botão Saber Mais */}
              <motion.div
                className="button-wrapper"
                variants={buttonVariants}
                
              >
                <Button 
                  variant="primary" 
                  className="learn-more-btn"
                  size="lg"
                  whileHover="hover"
                  href='/instituicao'
                >
                  Saber Mais
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </Button>
              </motion.div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </motion.section>
  );
}

export default AppAbout;